export default {
    cPurpose: {
        fr: 'Motif de consultation : ',
        en: 'Reason for consultation : ',
    },
};
